<template>
  <div
    class="indent_progress"
    :style="cssVars"
  >
    <div
      class="progress-bar progress-bar_first"
      :style="`${cssVars}; width: ${procent}%`"
      role="progressbar"
      aria-valuemin="0"
      aria-valuemax="100"
    />
  </div>
</template>

<script>
export default {
  props: {
    procent: {
      type: [Number, String],
      default: 0
    },
    green: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    cssVars() {
      return {
        "--progress-color-main": this.green ? "#28E593" : "#d8dad9",
        "--progress-color-bg": this.green ? "#28E59340" : "#eff1f0"
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.progress-bar {
  height: 10px;
  background-color: var(--progress-color-main);
  border-radius: 2px;

  position: absolute;
}

.app-dark {
  .indent_progress {
    background-color: var(--progress-color-bg);
  }
}

.indent_progress {
  height: 10px;
  border-radius: 2px;

  position: relative;

  background-color: var(--progress-color-bg);
}
</style>